import { CmsFieldDescriptor, CmsModuleDescriptor } from '@ndvr/cms-api';

export type CmsFieldDescriptorLookup = Record<string, CmsFieldDescriptor>;

export const CMS_FIELD_PATHS = {
    heroEyebrow: 'hero.eyebrow',
    heroHeadline: 'hero.headline',
    heroBody: 'hero.body',
    ctaLabel: 'cta.label',
    advisorProfileName: 'advisorProfile.name',
    advisorProfileTitle: 'advisorProfile.title',
    advisorProfileCredentials: 'advisorProfile.credentials[]',
    advisorProfileBio: 'advisorProfile.bio',
    advisorProfilePhone: 'advisorProfile.phone',
    advisorProfileEmail: 'advisorProfile.email',
    advisorProfileLocation: 'advisorProfile.location',
    contactSectionHeading: 'contactSection.heading',
    contactSectionBody: 'contactSection.body',
    contactSectionPhone: 'contactSection.phone',
    contactSectionEmail: 'contactSection.email',
    contactSectionAddressLines: 'contactSection.addressLines[]',
    contactSectionCtaLabel: 'contactSection.ctaLabel',
    leadFormDestinationEmail: 'leadForm.destinationEmail',
    leadFormEyebrow: 'leadForm.eyebrow',
    leadFormHeading: 'leadForm.heading',
    leadFormBody: 'leadForm.body',
    leadFormSubmitLabel: 'leadForm.submitLabel',
    leadFormSuccessMessage: 'leadForm.successMessage',
    infoCardGridEyebrow: 'infoCardGrid.eyebrow',
    infoCardGridHeading: 'infoCardGrid.heading',
    infoCardGridBody: 'infoCardGrid.body',
    infoCardGridItemTitle: 'infoCardGrid.items[].title',
    infoCardGridItemBody: 'infoCardGrid.items[].body',
    infoCardGridItemCtaLabel: 'infoCardGrid.items[].ctaLabel',
    mediaTextSectionEyebrow: 'mediaTextSection.eyebrow',
    mediaTextSectionHeading: 'mediaTextSection.heading',
    mediaTextSectionBody: 'mediaTextSection.body',
    mediaTextSectionCtaLabel: 'mediaTextSection.ctaLabel',
    processStepsEyebrow: 'processSteps.eyebrow',
    processStepsHeading: 'processSteps.heading',
    processStepsBody: 'processSteps.body',
    processStepsItemTitle: 'processSteps.steps[].title',
    processStepsItemBody: 'processSteps.steps[].body',
    quoteSectionEyebrow: 'quoteSection.eyebrow',
    quoteSectionQuote: 'quoteSection.quote',
    quoteSectionAttributionName: 'quoteSection.attributionName',
    quoteSectionAttributionTitle: 'quoteSection.attributionTitle',
    quoteSectionCtaLabel: 'quoteSection.ctaLabel',
    resourceListEyebrow: 'resourceList.eyebrow',
    resourceListHeading: 'resourceList.heading',
    resourceListBody: 'resourceList.body',
    resourceListItemTitle: 'resourceList.items[].title',
    resourceListItemDescription: 'resourceList.items[].description',
    resourceListItemLinkLabel: 'resourceList.items[].linkLabel',
    importantDisclosuresHeading: 'importantDisclosures.heading',
    importantDisclosureParagraphBody: 'importantDisclosures.paragraphs[].body',
    importantDisclosureFootnoteKey: 'importantDisclosures.footnotes[].key',
    importantDisclosureFootnoteLabel: 'importantDisclosures.footnotes[].label',
    importantDisclosureFootnoteBody: 'importantDisclosures.footnotes[].body',
    faqEyebrow: 'faq.eyebrow',
    faqHeading: 'faq.heading',
    faqItemQuestion: 'faq.items[].question',
    faqItemAnswer: 'faq.items[].answer',
} as const;

export const buildCmsFieldDescriptorLookup = (moduleDescriptors?: CmsModuleDescriptor[]): CmsFieldDescriptorLookup =>
    Object.fromEntries(
        moduleDescriptors?.flatMap((moduleDescriptor) =>
            (moduleDescriptor.fields ?? []).map((field) => [field.path, field]),
        ) ?? [],
    );

export const cmsFieldMaxLength = (fieldDescriptors: CmsFieldDescriptorLookup, path: string): number | undefined =>
    fieldDescriptors[path]?.maxLength;
